import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import PortalSidebar from "../components/PortalSidebar.tsx";
import { licenses, LicenseEntry } from "../data/licenses.ts";
import "./overview.css";

const formatHomepage = (entry: LicenseEntry) => {
  if (!entry.homepage) return "–";
  const label = entry.homepage.replace(/^https?:\/\//, "");
  return (
    <a href={entry.homepage} target="_blank" rel="noreferrer" className="portal-link">
      {label}
    </a>
  );
};

const formatLicenseLink = (entry: LicenseEntry) => {
  if (!entry.licenseFile) return "–";
  return (
    <a
      href={entry.licenseFile}
      target="_blank"
      rel="noreferrer"
      download
      className="portal-link"
    >
      Lizenztext
    </a>
  );
};

export default function Licenses() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return licenses;
    return licenses.filter((entry) => {
      return (
        entry.name.toLowerCase().includes(q) ||
        entry.license.toLowerCase().includes(q) ||
        (entry.homepage && entry.homepage.toLowerCase().includes(q))
      );
    });
  }, [query]);

  const uniqueLicenseTypes = useMemo(() => {
    return new Set(licenses.map((l) => l.license)).size;
  }, []);

  return (
    <div className="portal-root">
      <PortalSidebar />
      <main className="portal-main">
        <div className="portal-topbar portal-topbar-wide">
          <div>
            <div className="portal-title">Rechtliches</div>
            <p className="portal-subtitle">
              Transparente Übersicht aller verwendeten Open-Source-Komponenten und ihrer Lizenzen.
            </p>
          </div>
          <button className="btn light" onClick={() => navigate("/settings")}>
            ← Einstellungen
          </button>
        </div>
        <section className="portal-panel">
          <div className="portal-legal-meta">
            <span>{licenses.length} Pakete</span>
            <span>{uniqueLicenseTypes} Lizenztypen</span>
          </div>
          <div className="portal-search">
            <input
              placeholder="Nach Paket, Lizenz oder Quelle suchen"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
          <div className="portal-legal-table">
            <table className="portal-table2">
              <thead>
                <tr>
                  <th>Paket</th>
                  <th>Version</th>
                  <th>Lizenz</th>
                  <th>Quelle</th>
                  <th>Lizenztext</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((entry) => (
                  <tr key={`${entry.name}@${entry.version}`}>
                    <td>{entry.name}</td>
                    <td>{entry.version}</td>
                    <td>{entry.license}</td>
                    <td>{formatHomepage(entry)}</td>
                    <td>{formatLicenseLink(entry)}</td>
                  </tr>
                ))}
                {!filtered.length && (
                  <tr>
                    <td colSpan={5} style={{ textAlign: "center", color: "#2b6459" }}>
                      Keine Treffer gefunden.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </main>
    </div>
  );
}
